import { useMemo } from "react";
import { View } from "react-native";
import { PHOTO_LABEL_CREATION } from "src/api/featureFlags";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import { ValidShareOption } from "src/components/ShareMenu";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { AnimatePresence } from "src/swsh-native";
import { useShallow } from "zustand/shallow";
import useDeleteSelectedPhotos from "../../hooks/useDeleteSelectedPhotos";
import FloatingDeleteButton from "./components/FloatingDeleteButton";
import FloatingDownloadButton from "./components/FloatingDownloadButton";
import FloatingHideButton from "./components/FloatingHideButton";
import FloatingLabelButton from "./components/FloatingLabelButton";
import FloatingShareButton from "./components/FloatingShareButton";
import { FLOATING_SELECT_HORIZONTAL_MARGIN } from "./constants";

const FloatingSelectActionsContent = ({ options }: { options: ValidShareOption[] }) => {
	const { shareInfo, downloadInfo } = useMemo(() => {
		return {
			shareInfo: options.find((option) => option.key === "ShareShare"),
			downloadInfo: options.find((option) => option.key === "ShareDownload"),
		};
	}, [options]);
	const isEditing = useGatheringStore((state) => state.isEditing);
	const selectedPhotos = useGatheringStore(
		useShallow((state) => Object.values(state.selectedPhotos)),
	);
	const resetSelectMode = useGatheringStore((state) => state.resetSelectMode);
	const {
		promptDeletePhotos: handleDelete,
		hasDelete,
		deleteLoading,
	} = useDeleteSelectedPhotos(selectedPhotos, {
		onComplete: resetSelectMode,
	});
	const access = useGatheringStore((state) => state.access);

	return (
		<View
			style={{
				flexDirection: "row",
				alignItems: "center",
				marginHorizontal: -FLOATING_SELECT_HORIZONTAL_MARGIN,
			}}
		>
			<AnimatePresence>
				{hasDelete && (
					<FloatingDeleteButton
						key="Delete"
						loading={deleteLoading}
						onPress={handleDelete}
					/>
				)}
				{selectedPhotos.length > 0 &&
					PHOTO_LABEL_CREATION &&
					access === GatheringAccessEnum.Admin && (
						<FloatingLabelButton key="Label" selectedPhotos={selectedPhotos} />
					)}
				{selectedPhotos.length > 0 && access === GatheringAccessEnum.Admin && (
					<FloatingHideButton key="Hide" selectedPhotos={selectedPhotos} />
				)}
				{shareInfo && !isEditing && (
					<FloatingShareButton key="Share" data={shareInfo.data as any} />
				)}
				{downloadInfo && !isEditing && (
					<FloatingDownloadButton key="Download" data={downloadInfo.data as any} />
				)}
			</AnimatePresence>
		</View>
	);
};
export default FloatingSelectActionsContent;
